import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      leads: "Leads",
      contacts: "Contacts",
      company: "Company",
      importShipment: "Import Shipment",
      exportShipment: "Export Shipment",
      reports: "Reports",
      searchPlaceholder: "Search...",
      addNew: "Add New",
      Date: "Date",
      Client: "Client",
      Mobile: "Mobile",
      LeadSource: "Leads",
      LeadOwner: "Lead Owner",
      Status: "Status",
      Stage: "Stage",
      Priority: "Priority",
      LossReason: "Loss Reason",
      CreatedBy: "Created By",
      Action: "Action",
      Filter: "Filter",
      Create: "Create",
      Save: "Save",
      and: "and",
      New: "New",
      Cancel: "Cancel",
      firstName: "First Name",
    },
  },
  hi: {
    translation: {
      leads: "नेतृत्व",
      "Lead": "नेतृत्व",
      Management: "प्रबंध",
      contacts: "संपर्क",
      company: "कंपनी",
      importShipment: "आयात शिपमेंट",
      exportShipment: "निर्यात शिपमेंट",
      reports: "रिपोर्ट",
      report: "रिपोर्ट",
      searchPlaceholder: "खोजें...",
      addNew: "नया जोड़ें",
      Date: "तारीख",
      Client: "ग्राहक",
      Mobile: "मोबाइल",
      LeadSource: "लीड स्रोत",
      LeadOwner: "लीड मालिक",
      Status: "स्थिति",
      Stage: "मंच",
      Priority: "प्राथमिकता",
      LossReason: "हानि का कारण",
      CreatedBy: "द्वारा बनाया गया",
      Action: "कार्य",
      Filter: "फ़िल्टर",
      Create: "बनाएं",
      Save: "सहेजें",
      and: "और",
      New: "नया",
      Cancel: "रद्द करें",
      'First': "पहला",
      'Name': "नाम",
      firstName: "पहला नाम",
      "Clear": "साफ़",
      // @@@@@@@Start 
      "Leads": "लीड्स",
      "Contacts": "संपर्क",
      "Company": "कंपनी",
      "Import Shipment": "आयात शिपमेंट",
      "Export Shipment": "निर्यात शिपमेंट",
      "Reports": "रिपोर्ट",
      "Report": "रिपोर्ट",
      "Leads Management": "लीड प्रबंधन",
      "SN.": "क्र.सं.",
      "Date": "तारीख",
      "Country": "देश",
      "Contact Person": "संपर्क व्यक्ति",
      "Contact No.": "संपर्क नंबर",
      "Lead Status": "लीड स्थिति",
      "Source": "स्रोत",
      "Owner": "मालिक",
      "Purchase Date": "खरीद तिथि",
      "Action": "कार्रवाई",
      "Create Leads": "लीड बनाएँ",
      "Lead Owner": "लीड मालिक",
      "Title": "शीर्षक",
      "First Name": "पहला नाम",
      "Last Name": "अंतिम नाम",
      "Email": "ईमेल",
      "Phone": "फ़ोन",
      "Mobile": "मोबाइल",
      "Industry": "उद्योग",
      "Number of Employees": "कर्मचारियों की संख्या",
      "Annual Revenue": "वार्षिक राजस्व",
      "Rating": "रेटिंग",
      "Expected Date": "अपेक्षित तिथि",
      "Email Opt-Out": "ईमेल ऑप्ट-आउट",
      "Business Group": "व्यवसाय समूह",
      "Secondary Email": "द्वितीयक ईमेल",
      "Street": "सड़क",
      "State": "राज्य",
      "City": "शहर",
      "Zip Code": "पिन कोड",
      "Note": "नोट",
      "Enter": "प्रवेश करें",
      "Select": "चुनें",
      "Create": "बनाएँ",
      "Filter": "फ़िल्टर",
      "Save": "सहेजें",
      "save and new": "सहेजें और नया",
      "cancel": "रद्द करें",
      "Apply": "लागू करें",
      "clear": "साफ़ करें",
      "Create Contacts": "संपर्क बनाएँ",
      "Contact Admin": "संपर्क प्रशासक",
      "Asst Phone": "सहायक फ़ोन",
      "Assistant": "सहायक",
      "Department": "विभाग",
      "Skype Id": "स्काइप आईडी",
      "Email Opt Out": "ईमेल ऑप्ट-आउट",
      "Reporting To": "रिपोर्टिंग को",
      "Copy Address": "पता कॉपी करें",
      "Mailing Street": "मेलिंग सड़क",
      "Others Street": "अन्य सड़क",
      "Mailing Country": "मेलिंग देश",
      "Other Country": "अन्य देश",
      "Mailing State": "मेलिंग राज्य",
      "Other State": "अन्य राज्य",
      "Mailing City": "मेलिंग शहर",
      "Other City": "अन्य शहर",
      "Mailing Pincode": "मेलिंग पिनकोड",
      "Other Pincode": "अन्य पिनकोड",
      "Select Admin": "एडमिन चुनें",
      "Select Company": "कंपनी चुनें",
      "Enter First Name": "पहला नाम दर्ज करें",
      "Enter Last Name": "अंतिम नाम दर्ज करें",
      "Enter Email": "ईमेल दर्ज करें",
      "Enter Mobile": "मोबाइल दर्ज करें",
      "Enter Phone": "फ़ोन दर्ज करें",
      "Enter Asst Phone": "सहायक फ़ोन दर्ज करें",
      "Enter Assistant": "सहायक दर्ज करें",
      "Enter Business Group": "व्यवसाय समूह दर्ज करें",
      "Enter Skype Id": "स्काइप आईडी दर्ज करें",
      "Enter Secondary Email": "द्वितीयक ईमेल दर्ज करें",
      "Select Reporting To": "रिपोर्टिंग को चुनें",
      "Enter Mailing Street": "मेलिंग सड़क दर्ज करें",
      "Enter Other Street": "अन्य सड़क दर्ज करें",
      "Select Mailing Country": "मेलिंग देश चुनें",
      "Select Other Country": "अन्य देश चुनें",
      "Select Mailing State": "मेलिंग राज्य चुनें",
      "Select Other State": "अन्य राज्य चुनें",
      "Select Mailing City": "मेलिंग शहर चुनें",
      "Select Other City": "अन्य शहर चुनें",
      "Enter Mailing Pincode": "मेलिंग पिनकोड दर्ज करें",
      "Enter Other Pincode": "अन्य पिनकोड दर्ज करें",
      "Create Client Company": "क्लाइंट कंपनी बनाएँ",
      "Company Admin": "कंपनी प्रशासक",
      "Company Type": "कंपनी प्रकार",
      "Company Name": "कंपनी का नाम",
      "Website": "वेबसाइट",
      "Ownership": "स्वामित्व",
      "Industry Type": "उद्योग प्रकार",
      "Billing": "बिलिंग",
      "billing": "बिलिंग",
      "Billing Street": "बिलिंग सड़क",
      "Billing Country": "बिलिंग देश",
      "Billing State": "बिलिंग राज्य",
      "Billing City": "बिलिंग शहर",
      "Billing Pincode": "बिलिंग पिनकोड",
      "Notes": "नोट्स",
      "Select Company Admin": "कंपनी प्रशासक चुनें",
      "Select Company Type": "कंपनी प्रकार चुनें",
      "Enter Company Name": "कंपनी का नाम दर्ज करें",
      "Enter The Phone": "फ़ोन दर्ज करें",
      "Enter Website": "वेबसाइट दर्ज करें",
      "Select Rating": "रेटिंग चुनें",
      "Select Ownership": "स्वामित्व चुनें",
      "Select Industry Type": "उद्योग प्रकार चुनें",
      "Enter Number of Employees": "कर्मचारियों की संख्या दर्ज करें",
      "Enter Annual Revenue": "वार्षिक राजस्व दर्ज करें",
      "Select Business Group": "व्यवसाय समूह चुनें",
      "Enter Billing Street": "बिलिंग सड़क दर्ज करें",
      "Select Billing Country": "बिलिंग देश चुनें",
      "Select Billing State": "बिलिंग राज्य चुनें",
      "Select Billing City": "बिलिंग शहर चुनें",
      "Enter Billing Pincode": "बिलिंग पिनकोड दर्ज करें",
      "Write a Notes": "एक नोट लिखें",
      "Create Import Shipment": "आयात शिपमेंट बनाएँ",
      "Supplier": "आपूर्तिकर्ता",
      "Shipment ID": "शिपमेंट आईडी",
      "CIF/FOB": "सीआईएफ/एफओबी",
      "Expected ETD": "अपेक्षित ईटीडी",
      "Number of Containers": "कंटेनरों की संख्या",
      "No. of Container": "कंटेनरों की संख्या",
      "Currency": "मुद्रा",
      "Shipment Type": "शिपमेंट प्रकार",
      "Payment Method": "भुगतान विधि",
      "Port Of Loading": "लोडिंग पोर्ट",
      "Port Of Destination": "गंतव्य पोर्ट",
      "Create Export Shipment": "निर्यात शिपमेंट बनाएँ",
      "Customer": "ग्राहक",
      "Create Shipping Mark": "शिपिंग मार्क बनाएँ",
      "Batch Number": "बैच नंबर",
      "Select Product": "उत्पाद चुनें",
      "Shipping Mark": "शिपिंग मार्क",
      "Shipping": "शिपिंग",
      "Create Purchase Order": "खरीद आदेश बनाएँ",
      "Bill To": "बिल प्राप्तकर्ता",
      "Supplier Name": "आपूर्तिकर्ता का नाम",
      "Reference": "संदर्भ",
      "Purchase Order Details": "खरीद आदेश विवरण",
      "Purchase Order No.": "खरीद आदेश नंबर",
      "Purchase": "खरीद",
      "Particulars": "विशेष विवरण",
      "No.": "संख्या",
      "No": "संख्या",
      "Particular": "विवरण",
      "Qty": "मात्रा",
      "Rate": "दर",
      "Unit": "इकाई",
      "Amount": "राशि",
      "Select Product Name": "उत्पाद का नाम चुनें",
      "Enter Description": "विवरण दर्ज करें",
      "Quantity": "मात्रा",
      "Total": "कुल",
      "In Words": "शब्दों में",
      "Only": "केवल",
      "Summary": "सारांश",
      "Grand Total": "कुल योग",
      "Create Shipping Booking": "शिपिंग बुकिंग बनाएँ",
      "Proforma Invoice": "प्रोफार्मा चालान",
      "Select Type": "प्रकार चुनें",
      "Direct/Indirect": "प्रत्यक्ष/अप्रत्यक्ष",
      "Shipping Line": "शिपिंग लाइन",
      "Select Currency": "मुद्रा चुनें",
      "Sea Freight": "समुद्री मालभाड़ा",
      "ETD Date": "ईटीडी तिथि",
      "Cut-Off Date": "कट-ऑफ तिथि",
      "ETA Date": "ईटीए तिथि",
      "Base": "आधार",
      "In Base Currency": "आधार मुद्रा में",
      "CFS/Local Charges (In Base Currency)": "सीएफएस/स्थानीय शुल्क (आधार मुद्रा में)",
      "Shipping Line Charges (In Base Currency)": "शिपिंग लाइन शुल्क (आधार मुद्रा में)",
      "BL Charges (In Base Currency)": "बीएल शुल्क (आधार मुद्रा में)",
      "Others Charges (In Base Currency)": "अन्य शुल्क (आधार मुद्रा में)",
      "20FCL/40FCL": "20FCL/40FCL",
      "Freight Forward Agency": "माल अग्रेषण एजेंसी",
      "Clearing Agency (CHA)": "क्लीयरिंग एजेंसी (सीएचए)",
      "Free Days at Destination": "गंतव्य पर मुक्त दिन",
      "Payment Voucher": "भुगतान वाउचर",
      "Payment Voucher No.": "भुगतान वाउचर नंबर",
      "Base Currency": "आधार मुद्रा",
      "Conversion Rate (In Base)": "रूपांतरण दर (आधार में)",
      "Amount (In Base Currency)": "राशि (आधार मुद्रा में)",
      "Bank Charges (In Base Currency)": "बैंक शुल्क (आधार मुद्रा में)",
      "Commercial Invoice": "वाणिज्यिक चालान",
      "Payment Type": "भुगतान प्रकार",
      "Conversion Rate": "रूपांतरण दर",
      "Base Amount": "आधार राशि",
      "Create Expense Voucher": "व्यय वाउचर बनाएँ",
      "Expense Voucher No.": "व्यय वाउचर नंबर",
      "Due Date": "नियत तिथि",
      "Select Expense Ledger": "व्यय खाता चुनें",
      "Create Receipt Voucher": "रसीद वाउचर बनाएँ",
      "Receipt Voucher No.": "रसीद वाउचर नंबर",
      "Base Amount (In Base Currency)": "आधार राशि (आधार मुद्रा में)",
      "Create Proforma Invoice": "प्रोफार्मा चालान बनाएँ",
      "Proforma Invoice No.": "प्रोफार्मा चालान नंबर",
      "Advance": "अग्रिम",
      "Against LC": "एलसी के विरुद्ध",
      "Credit Day": "क्रेडिट दिन",
      "Create Commercial Invoice": "वाणिज्यिक चालान बनाएँ",
      "Commercial Invoice No.": "वाणिज्यिक चालान नंबर",
      "Description": "विवरण",
      "Upload Commercial Invoice": "वाणिज्यिक चालान अपलोड करें",
      "Create Duty and Tax": "शुल्क और कर बनाएँ",
      "Voucher No.": "वाउचर नंबर",
      "BOE Conversion Rate": "बीओई रूपांतरण दर",
      "BOE": "बीओई",
      "Product Name": "उत्पाद का नाम",
      "HSN No.": "एचएसएन नंबर",
      "Freight": "मालभाड़ा",
      "Insurance": "बीमा",
      "Duty": "शुल्क",
      "Tax": "कर",
      "Payment Reference Duty": "भुगतान संदर्भ शुल्क",
      "Invoice Amount": "चालान राशि",
      "Total Freight": "कुल मालभाड़ा",
      "Total Insurance": "कुल बीमा",
      "Total": "कुल",
      "total": "कुल",
      "Total Duty": "कुल शुल्क",
      "Total Tax": "कुल कर",
      "Upload BOE": "बीओई अपलोड करें",
      "Create Shipment Tracker": "शिपमेंट ट्रैकर बनाएँ",
      "Select BL No.": "बीएल नंबर चुनें",
      "Status": "स्थिति",
      "Shipment Tracker": "शिपमेंट ट्रैकर",
      "Incomplete": "अपूर्ण",
      "Attach Document": "दस्तावेज़ संलग्न करें",
      "Document Name": "दस्तावेज़ का नाम",
      "Create Product Photo": "उत्पाद फोटो बनाएँ",
      "Create Loading Photo": "लोडिंग फोटो बनाएँ",
      "Create Sales Order": "बिक्री आदेश बनाएँ",
      "Customer Name": "ग्राहक का नाम",
      "Sales Order No.": "बिक्री आदेश नंबर",
      "Create Sales Contract": "बिक्री अनुबंध बनाएँ",
      "Sales Contract No.": "बिक्री अनुबंध नंबर",
      "Create BL Draft": "बीएल ड्राफ्ट बनाएँ",
      "Shipper": "शिपर",
      "BL Number": "बीएल नंबर",
      "Order Method": "आदेश विधि",
      "Consignee": "प्राप्तकर्ता",
      "HS Code": "एचएस कोड",
      "Please Indicate any special requirement below": "कृपया नीचे कोई विशेष आवश्यकता दर्शाएँ",
      "Notify Party": "सूचना पक्ष",
      "Also Notify": "साथ ही सूचित करें",
      "Ocean Vessel Voy No.": "समुद्री पोत यात्रा नंबर",
      "Excess Value Declaration": "अधिशेष मूल्य घोषणा",
      "On Board Date": "ऑन बोर्ड तिथि",
      "Final Destination": "अंतिम गंतव्य",
      "Freight Payable at": "मालभाड़ा भुगतान योग्य",
      "No. of Originals": "मूल की संख्या",
      "Marks": "निशान",
      "No. Of PKGS": "पैकेजों की संख्या",
      "Description of Goods": "सामान का विवरण",
      "Gross Weight": "सकल वजन",
      "Measurement": "माप",
      "Seal No.": "सील नंबर",
      "Type": "प्रकार",
      "Create COA": "सीओए बनाएँ",
      "Certification Of Analysis": "विश्लेषण प्रमाण पत्र",
      "To": "को",
      "Inv. No": "चालान नंबर",
      "Loading Port": "लोडिंग पोर्ट",
      "Destination Port": "गंतव्य पोर्ट",
      "MFG. date": "निर्माण तिथि",
      "Expiry date": "समाप्ति तिथि",
      "Test date": "परीक्षण तिथि",
      "Package": "पैकेज",
      "Batch No.": "बैच नंबर",
      "SN": "क्रम संख्या",
      "Items": "वस्तुएँ",
      "Standard": "मानक",
      "Result": "परिणाम",
      "Conclusion": "निष्कर्ष",
      "Analyst": "विश्लेषक",
      "Examiner": "परीक्षक",
      "Approved": "स्वीकृत",
      "CAS No": "सीएएस नंबर",
      "IUPAC": "आईयूपैक",
      "Create COO": "सीओओ बनाएँ",
      "Original": "मूल",
      "Exporter": "निर्यातक",
      "Serial No.": "क्रम संख्या",
      "Serial": "क्रम",
      "Certificate No.": "प्रमाणपत्र नंबर",
      "Certificate": "प्रमाणपत्र",
      "Certification of Origin": "मूल प्रमाण पत्र",
      "Means Of Transport And Route": "परिवहन का साधन और मार्ग",
      "Country / Region of Destination": "गंतव्य देश / क्षेत्र",
      "For Certifying Authority Use Only": "केवल प्रमाणन प्राधिकरण के उपयोग के लिए",
      "Marks and No.": "निशान और संख्या",
      "No. and Kind of Packages; Description of Goods": "पैकेजों की संख्या और प्रकार; सामान का विवरण",
      "H.S Code": "एच.एस कोड",
      "No. and Date of Invoices": "चालानों की संख्या और तिथि",
      "Declaration by Exporter": "निर्यातक द्वारा घोषणा",
      "Place and Date, Signature and Stamp of Authorized Signatory": "स्थान और तिथि, अधिकृत हस्ताक्षरकर्ता के हस्ताक्षर और मोहर",
      "Certification": "प्रमाणीकरण",
      "Place and Date, Signature and Stamp of Certifying Authority": "स्थान और तिथि, प्रमाणन प्राधिकरण के हस्ताक्षर और मोहर",
      "Create Packing List": "पैकिंग सूची बनाएँ",
      "Packing List": "पैकिंग सूची",
      "SC No.": "एससी नंबर",
      "Table Columns": "तालिका कॉलम",
      "Mark": "निशान",
      "PKG": "पैकेज",
      "G.W. (Gross Weight)": "सकल वजन",
      "N.W. (Net Weight)": "शुद्ध वजन",
      "Measurement": "माप",
      "Total Packed In": "कुल पैक किया गया",
      "Total Gross Weight": "कुल सकल वजन",
      "Total Net Weight": "कुल शुद्ध वजन",
      "Net Weight": "शुद्ध वजन",
      "Setup": "सेटअप",
      "GENERAL": "सामान्य",
      "Personal Settings": "व्यक्तिगत सेटिंग्स",
      "Company Settings": "कंपनी सेटिंग्स",
      "Company Bank": "कंपनी बैंक",
      "User Management": "उपयोगकर्ता प्रबंधन",
      "Security Control": "सुरक्षा नियंत्रण",
      "Profiles": "प्रोफाइल",
      "Roles And Sharing": "भूमिकाएँ और साझा करना",
      "System Setting": "सिस्टम सेटिंग",
      "Terms & Conditions": "नियम और शर्तें",
      "Master": "मास्टर",
      "Expense Ledger Group": "व्यय खाता समूह",
      "Shipping Line Master": "शिपिंग लाइन मास्टर",
      "Freight Forward Master": "माल अग्रेषण मास्टर",
      "Custom Clearing Agency": "कस्टम क्लियरिंग एजेंसी",
      "Products": "उत्पाद",
      "Products Group": "उत्पाद समूह",
      "Manage Products": "उत्पाद प्रबंधित करें",
      "Unit Master": "यूनिट मास्टर",
      "Business Master": "व्यवसाय मास्टर",
      "Contact Group": "संपर्क समूह",
      "Contact Types": "संपर्क प्रकार",
      "Status Master": "स्थिति मास्टर",
      "Task Statuses": "कार्य स्थितियाँ",
      "Ratings": "रेटिंग्स",
      "Lead Statuses": "लीड स्थितियाँ",
      "Lead Sources": "लीड स्रोत",
      "Loss Reasons": "हानि के कारण",
      "Priorities": "प्राथमिकताएँ",
      "Customization": "अनुकूलन",
      "Modules": "मॉड्यूल",
      "Template": "टेम्पलेट",
      "Color Plate": "रंग प्लेट",
      "Subscription Plans": "सदस्यता योजनाएँ",
      "Subscription History": "सदस्यता इतिहास",
      "Update Company": "कंपनी अपडेट करें",
      "Company URL": "कंपनी यूआरएल",
      "Telephone": "टेलीफोन",
      "Fax": "फैक्स",
      "Address": "पता",
      "Address Line One": "पता पंक्ति एक",
      "Address Line Two": "पता पंक्ति दो",
      "Pincode": "पिनकोड",
      "GSTIN": "जीएसटीआईएन",
      "Fiscal Year Begin Month": "वित्तीय वर्ष प्रारंभ माह",
      "Financial Year Start": "वित्तीय वर्ष प्रारंभ",
      "Financial Year End": "वित्तीय वर्ष समाप्ति",
      "Create Company Bank": "कंपनी बैंक बनाएँ",
      "Bank Name": "बैंक का नाम",
      "Account Number": "खाता संख्या",
      "Account Holder Name": "खाता धारक का नाम",
      "SWIFT Code": "स्विफ्ट कोड",
      "IFSC Code": "आईएफएससी कोड",
      "Bank Branch": "बैंक शाखा",
      "Bank Address": "बैंक का पता",
      "Ledger": "लेजर",
      "Ledger Name": "लेजर का नाम",
      "Ledger Short Name": "लेजर का संक्षिप्त नाम",
      "Shipping Line Name": "शिपिंग लाइन का नाम",
      "Short Name": "संक्षिप्त नाम",
      "Agency": "एजेंसी",
      "Agency Name": "एजेंसी का नाम",
      "Mobile Number": "मोबाइल नंबर",
      "Phone Number": "फ़ोन नंबर",
      "Select Color": "रंग चुनें",
      "Product Group": "उत्पाद समूह",
      "Product Group Name": "उत्पाद समूह का नाम",
      "Add Product": "उत्पाद जोड़ें",
      "Client": "ग्राहक",
      "Client Company": "ग्राहक कंपनी",
      "Product Details": "उत्पाद विवरण",
      "HSN Number": "एचएसएन नंबर",
      "Duty Percentage": "शुल्क प्रतिशत",
      "Tax Percentage": "कर प्रतिशत",
      "Alternate Unit": "वैकल्पिक इकाई",
      "Primary Quantity": "प्राथमिक मात्रा",
      "Primary Unit": "प्राथमिक इकाई",
      "Secondary Quantity": "द्वितीयक मात्रा",
      "Secondary Unit": "द्वितीयक इकाई",
      "Unit Type": "इकाई प्रकार",
      "Short Form of Unit": "इकाई का संक्षिप्त रूप",
      "Formal Name": "औपचारिक नाम",
      "Unit Quality Code (UQC)": "इकाई गुणवत्ता कोड (यूक्यूसी)",
      "No. Of Decimal Places": "दशमलव स्थानों की संख्या",
      "Business Group Name": "व्यवसाय समूह का नाम",
      "Contact Group Name": "संपर्क समूह का नाम",
      "Contact Type Name": "संपर्क प्रकार का नाम",
      "Task Status": "कार्य स्थिति",
      "Rating Name": "रेटिंग का नाम",
      "Priority": "प्राथमिकता",
      "Lead Source": "लीड स्रोत",
      "Loss Reason Name": "हानि कारण का नाम",
      "Priority Name": "प्राथमिकता का नाम",
      "Price Estimate": "मूल्य अनुमान",
      "Basic Subscription Fees": "मूल सदस्यता शुल्क",
      "2 users and 1 Company Included*": "2 उपयोगकर्ता और 1 कंपनी शामिल*",
      "Per 12 Month": "प्रति 12 माह",
      "Users Subscription": "उपयोगकर्ता सदस्यता",
      "Company Subscription": "कंपनी सदस्यता",
      "Discounted Price (10% OFF)": "छूट मूल्य (10% की छूट)",
      "Yearly Total Subscription Amount": "वार्षिक कुल सदस्यता राशि",
      "Add Users and Company to Your Existing Subscription Plan": "अपने मौजूदा सदस्यता योजना में उपयोगकर्ता और कंपनी जोड़ें",
      "Additional Users": "अतिरिक्त उपयोगकर्ता",
      "Additional Company": "अतिरिक्त कंपनी",
      "Note: Price is applied per user and company with the remaining subscription days": "नोट: मूल्य शेष सदस्यता दिनों के साथ प्रति उपयोगकर्ता और कंपनी लागू होता है",
      "Create Call": "कॉल बनाएँ",
      "Select Call Type": "कॉल प्रकार चुनें",
      "Select Contact Person": "संपर्क व्यक्ति चुनें",
      "Subject": "विषय",
      "Calling Type": "कॉलिंग प्रकार",
      "Inbound": "इनबाउंड",
      "Outbound": "आउटबाउंड",
      "Call Details": "कॉल विवरण",
      "Details": "विवरण",
      "Current": "वर्तमान",
      "Complete": "पूर्ण",
      "Scheduled": "निर्धारित",
      "Call Start Time": "कॉल शुरू होने का समय",
      "Call Duration": "कॉल की अवधि",
      "Call Purpose": "कॉल का उद्देश्य",
      "Call Outcome": "कॉल परिणाम",
      "Lead Stage": "लीड चरण",
      "Loss Reason": "हानि का कारण",
      "Create Task": "कार्य बनाएँ",
      "Task Owner": "कार्य मालिक",
      "Assign To": "को सौंपें",
      "Task": "कार्य",
      "overView": "समीक्षा",
      "Overview": "समीक्षा",
      "purchase Order": "खरीद आदेश",
      "booking": "बुकिंग",
      "payment": "भुगतान",
      "expense": "व्यय",
      "receipt Voucher": "रसीद वाउचर",
      "Duty/Tax": "शुल्क/कर",
      "tracker": "ट्रैकर",
      "document": "दस्तावेज़",
      "sales Order": "बिक्री आदेश",
      "sales contract": "बिक्री अनुबंध",
      "expense voucher": "व्यय वाउचर",
      "bL draft": "बीएल ड्राफ्ट",
      "COA": "सीओए",
      "COO": "सीओओ",
      "shipment booking": "शिपमेंट बुकिंग",
      "is required": "आवश्यक है",
      "ID": "आईडी",
      "From Date": "तारीख से",
      "To Date": "तारीख तक",
      "shipping Mark": "शिपिंग मार्क",
      "shipping mark": "शिपिंग मार्क",
      "proforma Invoice": "प्रोफार्मा चालान",
      "proforma invoice": "प्रोफार्मा चालान",
      "commercial Invoice": "वाणिज्यिक चालान",
      "commercial invoice": "वाणिज्यिक चालान",
      "receipt voucher": "रसीद वाउचर",
      "packing list": "पैकिंग सूची",
      "CIF": "सीआईएफ",
      "FOB": "एफओबी",
      "Types": "प्रकार",
      "Search": "खोज",
      "Update": "अद्यतन",
      "Email Opt-Out": "ईमेल ऑप्ट-आउट",
      "Address": "पता",
      "Information": "जानकारी",
      "Shipment": "शिपमेंट",
      "shipment": "शिपमेंट",
      "Others": "अन्य",
      "Charges": "शुल्क",
      "Sea": "समुद्र",
      "BL Charges": "बीएल शुल्क",
      "currency": "मुद्रा",
      "conversion": "रूपांतरण",
      "In": "में",
      "Bank Charges": "बैंक शुल्क",
      "Expense": "व्यय",
      "due": "देय",
      "receipt": "रसीद",
      "base currency": "मूल मुद्रा",
      "freight": "भाड़ा",
      "insurance": "बीमा",
      "Attach": "संलग्न",
      "in": "में",
      "Voucher": "वाउचर",
      "Expense": "व्यय",
      "Receipt": "रसीद",
      "Sales": "बिक्री",
      "Order": "आदेश",
      "Contract": "अनुबंध",
      "BL": "बिल ऑफ लैडिंग",
      "Draft": "मसौदा",
      "Booking": "बुकिंग",
      "of": "की",
      "Containers": "कंटेनर",
      "Id": "आईडी",
      "Product": "उत्पाद",
      "product": "उत्पाद",
      "qty": "मात्रा",
      "Summary": "सारांश",
      "Port": "बंदरगाह",
      "Loading": "लोडिंग",
      "loading": "लोडिंग",
      "Destination": "गंतव्य",
      "destination": "गंतव्य",
      "Sea": "समुद्र",
      "Freight": "भाड़ा",
      "is required": "आवश्यक है",
      "CFS": "कंटेनर फ्रेट स्टेशन",
      "Local Charges": "स्थानीय शुल्क",
      "In": "में",
      "Base": "आधार",
      "Currency": "मुद्रा",
      "Shipping Line": "शिपिंग लाइन",
      "Charges": "शुल्क",
      "BL Charges": "बीएल शुल्क",
      "Others Charges": "अन्य शुल्क",
      "Per Con.": "प्रति कंटेनर",
      "are required": "आवश्यक हैं",
      "Clearing": "क्लियरिंग",
      "20FCL/40FCL": "20 एफसीएल / 40 एफसीएल",
      "currency": "मुद्रा",
      "In": "में",
      "PI": "प्रोफार्मा इनवॉइस",
      "CI": "कमर्शियल इनवॉइस",
      "amount": "राशि",
      "reference": "संदर्भ",
      "Final": "अंतिम",
      "select Against": "के विरुद्ध चुनें",
      "port": "बंदरगाह",
      "Of": "का",
      "Commercial": "वाणिज्यिक",
      "Invoice": "चालान",
      "order": "आदेश",
      "proforma": "प्रोफार्मा",
      "Inv.": "इनवॉइस",
      "HSN": "एचएसएन",
      "And": "और",
      "New": "नया",
      "Upload": "डालना",
      "Write": "लिखना",
      "a": "ए",
      "More": "अधिक",
      "Number": "संख्या",
      "Related": "संबंधित",
      "List": "सूची",
      "calls": "कॉल",
      "Call": "कॉल",
      "call": "कॉल",
      "tasks": "कार्य",
      "Tasks": "कार्य",
      "notes": "नोट",
      "General": "सामान्य",
      "Term & Conditions": "नियम एवं शर्तें",
      "Term": "नियम",
      "Terms": "नियम",
      "Conditions": "शर्तें",
      "group": "समूह",
      "Manage": "प्रबंधित करें",
      "Persentage": "प्रतिशत",
      "priority": "प्राथमिकता",
      "Module": "मॉड्यूल",
      "Template": "टेम्पलेट",
      "Color": "रंग",
      "color": "रंग",
      "Forward": "फॉरवर्ड",
      "short": "संक्षिप्त",
      "required": "आवश्यक",
      "shipping": "शिपिंग",
      "Line": "लाइन",
      "agency": "एजेंसी",
      "contact": "संपर्क",
      "Person": "व्यक्ति",
      "number": "संख्या",
      "country": "देश",
      "products": "उत्पाद",
      "Group": "समूह",
      "duty": "शुल्क",
      "unit": "इकाई",
      "Short": "संक्षिप्त",
      "Form": "प्रपत्र",
      "Quality": "गुणवत्ता",
      "Code": "कोड",
      "Decimal": "दशमलव",
      "Places": "स्थान",
      "business": "व्यवसाय",
      "task": "कार्य",
      "rating": "रेटिंग",
      "lead": "लीड",
      "loss": "हानि",
      "Reason": "कारण",
      "Free": "मुफ़्त",
      "Days": "दिन",
      "days": "दिन",
      "wise": "अनुसार",
      "Wise": "अनुसार",
      "date": "तारीख",
      "Proform": "प्रोफॉर्म",
      "Register": "पंजीकरण",
      "Batch": "बैच",
      "Import": "आयात",
      "import": "आयात",
      "Payment": "भुगतान",
      "Export": "निर्यात",
      "export": "निर्यात",
      "Costing": "लागत निर्धारण",
      "Cost": "लागत",
      "cost": "लागत",
      "costing": "लागत निर्धारण",
      "Tracking": "ट्रैकिंग",
      "Import": "आयात",
      "Export": "निर्यात",
      "Imp.": "आयात",
      "Exp.": "निर्यात",
      "Advance": "अग्रिम",
      "Final": "अंतिम",
      "Balance": "शेष",
      "advance": "अग्रिम",
      "final": "अंतिम",
      "balance": "शेष",
      "remaining": "शेष",
      "day": "दिन",
      "Remaining": "शेष",
      "Day": "दिन",
      "Documents": "दस्तावेज़",
      "Container": "कंटेनर",
      "per": "प्रति",
      "Transport": "परिवहन",
      "Primary": "प्राथमिक",
      "Secondary": "माध्यमिक",
      "With": "सहित",
      "Without": "बिना",
      "primary": "प्राथमिक",
      "secondary": "माध्यमिक",
      "with": "सहित",
      "without": "बिना",
      "custom": "सीमा शुल्क",
      "expenses": "खर्चे",
      "Custom": "सीमा शुल्क",
      "Expenses": "खर्चे",
      "miscellaneous": "विविध",
      "Miscellaneous": "विविध",
      "by": "द्वारा",
      "Start": "प्रारंभ",
      "Time": "समय",
      "Duration": "अवधि",
      "Purpose": "उद्देश्य",
      "Out": "बाहर",
      "Come": "आना",
      "Contact": "संपर्क",
      "Owneris": "मालिक",
      "Expected": "अपेक्षित",
      "Bank": "बैंक",
      "Admin": "प्रशासक",
      "Login": "लॉगिन",
      "User": "उपयोगकर्ता",
      "Role": "भूमिका",
      "Profile": "प्रोफ़ाइल",
      "Suffix": "प्रत्यय",
      "Prefix": "उपसर्ग",
      "Shipment ID Setting": "शिपमेंट आईडी सेटिंग",
      "Import Shipment Id Manual": "आयात शिपमेंट आईडी मैनुअल",
      "Export Shipment Id Manual": "निर्यात शिपमेंट आईडी मैनुअल",
      "Import Shipment Prefix and suffix Setting": "आयात शिपमेंट उपसर्ग और प्रत्यय सेटिंग",
      "Purchase Order": "क्रय आदेश",
      "Export Shipment Prefix and suffix Setting": "निर्यात शिपमेंट उपसर्ग और प्रत्यय सेटिंग",
      "Sales Order": "बिक्री आदेश",
      "Financial Year": "वित्तीय वर्ष",
      "Date Format": "तिथि प्रारूप",
      "Language": "भाषा",
      " Goods": "सामान",
      "Packages": "पैकेज",
      "Level": "स्तर",
      "Approval": "अनुमोदन",
      "For Certifiying authority use Only": "केवल प्रमाणीकरण प्राधिकारी के उपयोग के लिए",
      "Place and Date, Signature and stamp of Authorized Signatory": "स्थान और तिथि, अधिकृत हस्ताक्षरकर्ता के हस्ताक्षर और मुहर",
      "It is hereby certified that the declaration by the exporter is correct": "यह प्रमाणित किया जाता है कि निर्यातक द्वारा की गई घोषणा सही है",
      "Place and Date, Signature and stamp of Certifying Authority": "स्थान और तिथि, प्रमाणीकरण प्राधिकारी के हस्ताक्षर और मुहर",
      "the People's Republic Of": "जनवादी गणराज्य",

      "The undersigned hereby declares that the above details and statements are correct, that the goods were produced in ": "निम्न हस्ताक्षरकर्ता द्वारा यह घोषित किया जाता है कि उपरोक्त विवरण और वक्तव्य सही हैं, कि माल ",
      "and that they comply with the rules of origin of the People's Republic of ": " और यह जनवादी गणराज्य के उद्गम नियमों का पालन करता है ",
      "Reference": "संदर्भ",
      "Seal": "मुहर",
      "Are you sure you want to delete this item? This action cannot be undone": "क्या आप वाकई इस आइटम को हटाना चाहते हैं? इस क्रिया को वापस नहीं लिया जा सकता।",
      "Delete": "हटाएँ",
      "Confirm Deletion": "हटाने की पुष्टि करें",
      "Registered": "पंजीकृत",
      "Financial": "वित्तीय",
      "Year": "वर्ष",
      "End": "समाप्ति",
      "Roles": "भूमिकाएँ",
      "Created": "निर्मित",
      "Permission": "अनुमति",
      "Permissions": "अनुमतियाँ",
      "PAN": "पैन",
      "IEC": "आईईसी",
      "GST": "जीएसटी",
      "Info": "जानकारी",
      "Certifying Authority": "प्रमाणित प्राधिकारी",
      "Monthly": "मासिक",
      "No Record Found!": "कोई रिकॉर्ड नहीं मिला!",
      "On": "पर",
      "Ordered": "आदेशित",
      "Pending": "लंबित",
      "In-Transit": "परिवहन में",
      "Top": "शीर्ष",
      "Payable": "देय",
      "Receive": "प्राप्त",
      "Growth": "विकास",
      "Progress": "प्रगति",
      "Chart": "चार्ट",



      // @@@@@@@ end


    },
  },
  zh: {
    translation: {
      leads: "线索",
      contacts: "联系人",
      company: "公司",
      importShipment: "进口货物",
      exportShipment: "出口货物",
      reports: "报告",
      searchPlaceholder: "搜索...",
      addNew: "新增",
      LeadSource: "线索",
      Date: "日期",
      Client: "客户",
      Mobile: "手机号",
      LeadOwner: "潜在客户负责人",
      Status: "状态",
      Stage: "阶段",
      Priority: "优先级",
      LossReason: "失败原因",
      CreatedBy: "创建者",
      Action: "操作",
      Filter: "筛选",
      Create: "创建",
      Save: "保存",
      and: "并",
      New: "新增",
      Cancel: "取消",
      firstName: "名",
      "Leads": "领导者",
      "Contacts": "联系人/联系方式",
      "Company": "公司",
      "Import Shipment": "进口货物运输",
      "Export Shipment": "出口货物运输",
      "Reports": "报告",
      "Leads Management": "潜在客户管理",
      "SN.": "序列号",
      "Date": "日期",
      "Country": "国家",
      "Contact Person": "联系人",
      "Contact No.": "联系电话",
      "Lead Status": "潜在客户状态",
      "Source": "来源",
      "Purchase Date": "购买日期",
      "Action": "行动",
      "Create Leads": "获取潜在客户",
      "Lead Owner": "潜在客户负责人",
      "Title": "职位头衔",
      "First Name": "名字",
      "Last Name": "姓氏",
      "Email": "邮箱",
      "Phone": "电话号码",
      "Mobile": "手机号码",
      "Industry": "行业",
      "Number of Employees": "员工人数",
      "Annual Revenue": "年收入",
      "Rating": "等级",
      "Expected Date": "预计日期",
      "Email Opt-Out": "邮件退订",
      "Business Group": "商业集团/业务群组",
      "Secondary Email": "备用邮箱",
      "Street": "街道",
      "State": "州；省份",
      "City": "城市",
      "Zip Code": "邮政编码",
      "Note": "备注；票据",
      "Enter": "进入；登记",
      "Select": "选择",
      "Create": "创建",
      "Filter": "筛选",
      "Save ": "保存；储蓄",
      "save and new": "保存并新建",
      "cancel": "取消",
      "Apply": "应用",
      "clear": "清除",
      "Create Contacts": "创建联系人",
      "Contact Admin": "联系管理员",
      "Asst Phone": "助理电话",
      "Assistant": "助理",
      "Department": "部门",
      "Skype Id": "Skype账号",
      "Email Opt Out": "电子邮件退订服务",
      "Reporting To": "汇报给",
      "Address Information": "地址信息",
      "Copy Address": "复制地址",
      "Mailing Street": "邮寄街道地址",
      "Others Street": "其他街道地址",
      "Mailing Country": "邮寄国家",
      "Other Country": "其他国家",
      "Mailing State": "邮寄省份",
      "Other State": "其他省份",
      "Mailing City": "邮寄城市",
      "Other City": "其他城市",
      "Mailing Pincode": "邮寄邮政编码",
      "Other Pincode": "其他邮政编码",
      "Select Admin": "选择管理员",
      "Select Company": "选择公司",
      "Enter First Name": "输入名字",
      "Enter Last Name": "输入姓氏",
      "Enter Email": "输入电子邮箱",
      "Enter Mobile": "输入手机号码",
      "Enter Phone": "输入电话号码",
      "Enter Asst Phone": "输入助理电话号码",
      "Enter Assistant": "输入助理信息",
      "Enter Business Group": "输入企业集团",
      "Enter Skype Id": "输入Skype 账号",
      "Enter Secondary Email": "输入备用邮箱",
      "Select Reporting To": "选择汇报给",
      "Enter Mailing Street": "输入邮寄街道",
      "Enter Other Street": "输入其他街道",
      "Select Mailing Country": "选择邮寄国家",
      "Select Other Country": "选择其他国家",
      "Select Mailing State": "选择邮寄省份/州",
      "Select Other State": "选择其他省份/州",
      "Select Mailing City": "选择邮寄城市",
      "Select Other City": "选择其他城市",
      "Enter Mailing Pincode": "输入邮寄邮政编码",
      "Enter Other Pincode": "输入其他编码",
      "Create Client Company": "创建客户公司",
      "Company Admin": "公司管理员",
      "Company Type": "公司类型",
      "Company Name": "公司名称",
      "Website": "网址",
      "Ownership": "所有权/股权结构",
      "Industry Type": "行业类型",
      "Billing Street": "账单街道地址",
      "Billing Country": "账单国家",
      "Billing State": "账单省份",
      "Billing City": "账单城市",
      "Billing Pincode": "账单邮政编码",
      "Notes": "备注；票据",
      "Select Company Admin": "选择公司管理员",
      "Select Company Type": "选择公司类型",
      "Enter Company Name": "输入公司名字",
      "Enter The Phone": "输入电话号码",
      "Enter Website": "输入网址",
      "Select Rating": "选择评级",
      "Select Ownership": "选择所有权/股权结构",
      "Select Industry Type": "选择行业类型",
      "Enter Number of Employees": "输入员工人数",
      "Enter Annual Revenue": "输入年收入",
      "Select Business Group": "选择企业集团",
      "Enter Billing Street": "输入账单街道",
      "Select Billing Country": "选择账单国家",
      "Select Billing State": "选择账单省份/州",
      "Select Billing City": "选择账单城市",
      "Enter Billing Pincode": "输入账单邮政编码",
      "Write a Notes": "写一条备注",
      "Create Import Shipment": "创建进口货运",
      "Supplier": "供应商",
      "Shipment ID": "货运编号/运单号",
      "CIF/FOB": "成本、保险费加运费/离岸价",
      "Expected ETD": "预计离港时间",
      "Number of Containers": "集装箱数量",
      "Currency": "货币",
      "Shipment Type": "货运类型",
      "Payment Method": "支付方式",
      "Port Of Loading": "卸货港",
      "Port Of Destination": "目的港",
      "Create Export Shipment": "创建出口货运",
      "Customer": "客户",
      "Create Shipping Mark": "创建唛头",
      "Batch Number": "批号",
      "Select Product": "选择产品",
      "Shipping Mark": "唛头",
      "Create Purchase Order": "创建采购订单",
      "Bill To": "付款方",
      "Supplier Name": "供应商名称",
      "Reference": "编号/参考信息",
      "Purchase Order Details": "采购订单详情",
      "Purchase Order No.": "采购订单号",
      "Particulars": "详情",
      "No.": "编号",
      "Particular": "详情",
      "Qty": "数量",
      "Rate": "单价/费率/汇率",
      "Unit": "单位",
      "Amount": "金额",
      "Select Product Name": "选择产品名称",
      "Enter Description": "输入描述",
      "Quantity": "数量",
      "Total": "总数",
      "In Words": "文字描述（金额）",
      "Only": "整",
      "Summary": "总结",
      "Grand Total": "总计",
      "Create Shipping Booking": "创建货运订舱",
      "Proforma Invoice": "形式发票",
      "Select Type": "选择类型",
      "Direct/Indirect": "直接/间接；直达/中转",
      "Shipping Line": "航运公司",
      "Select Currency": "选择货币",
      "Sea Freight": "海运费",
      "ETD Date": "离港日期",
      "Cut-Off Date": "截单日期",
      "ETA Date": "到港日期",
      "CFS/Local Charges (In Base Currency)": "集装箱货运站/本地费用（以本币计价）",
      "Shipping Line Charges (In Base Currency)": "航运公司费用（以本币计价）",
      "BL Charges (In Base Currency)": "提单相关费用",
      "Others Charges (In Base Currency)": "其他费用",
      "20FCL/40FCL": "20 英尺整箱/40英尺整箱",
      "Freight Forward Agency": "货运代理公司",
      "Clearing Agency (CHA)": "清算机构",
      "Free Days at Destination": "目的港免费天数",
      "Payment Voucher": "付款凭证",
      "Payment Voucher No.": "付款凭证编号",
      "Base Currency": "本币",
      "Conversion Rate (In Base)": "货币汇率",
      "Amount (In Base Currency)": "金额（以本币计算）",
      "Bank Charges (In Base Currency)": "银行手续费",
      "Commercial Invoice": "商业发票",
      "Payment Type": "支付方式",
      "Conversion Rate": "汇率",
      "Base Amount": "基本金额",
      "Create Expense Voucher": "创建费用凭证",
      "Expense Voucher No.": "费用凭证编号",
      "Due Date": "到期日",
      "Select Expense Ledger": "选择费用分类账",
      "Create Receipt Voucher": "创建收据凭证",
      "Receipt Voucher No.": "收据凭证编号",
      "Base Amount (In Base Currency)": "基本金额",
      "Create Proforma Invoice": "创建形式发票",
      "Proforma Invoice No.": "形式发票编号",
      "Advance": "预付款",
      "Against LC": "凭信用证",
      "Credit Day": "信用日",
      "Create Commercial Invoice": "创建商业发票",
      "Commercial Invoice No.": "商业发票编号",
      "Description": "描述",
      "Upload Commercial Invoice": "上传商业发票",
      "Create Duty and Tax": "创建关税和税费",
      "Voucher No.": "凭证编号",
      "BOE Conversion Rate": "BOE转换率",
      "Product Name": "产品名称",
      "HSN No.": "海关编码号",
      "Freight": "运费",
      "Insurance": "保险费",
      "Duty": "关税",
      "Tax": "税费",
      "Payment Reference Duty": "关税付款参考",
      "Invoice Amount": "发票金额",
      "Total Freight": "总运费",
      "Total Insurance": "总保险费",
      "Total Duty": "总关税",
      "Total Tax": "总税额",
      "Upload BOE": "上传提单",
      "Create Shipment Tracker": "创建货物追踪器",
      "Select BL No.": "选择提单号",
      "Status": "状态",
      "Shipment Tracker": "货物追踪器",
      "Incomplete": "未完成；不完整",
      "Attach Document": "附加文件",
      "Document Name": "文件名称",
      "Create Product Photo ": "创建产品照片",
      "Create Loading Photo": "创建装货照片",
      "Create Sales Order": "创建销售订单",
      "Customer Name": "客户名称",
      "Sales Order No.": "销售订单号",
      "Create Sales Contract": "创建销售合同",
      "Sales Contract No.": "销售合同号",
      "Create BL Draft": "创建草稿提单",
      "Shipper": "托运人",
      "BL Number": "提单号",
      "Order Method": "订货方式",
      "Consignee": "收货人",
      "HS Code": "协调制度编码",
      "Please Indicate any special requirement below": "请在下方注明任何特殊要求。",
      "Notify Party": "通知收货人",
      "Also Notify": "也通知...",
      "Ocean Vessel Voy No.": "轮船编号",
      "Excess Value Declaration": "超额价值申报",
      "On Board Date": "装船日期",
      "Final Destination": "最终目的地",
      "Freight Payable at": "运费到付",
      "No. of Originals": "正本份数",
      "Marks": "标记；唛头",
      "No. Of PKGS": "件数",
      "Description of Goods": "货物描述",
      "Gross Weight": "毛重",
      "Measurement": "体积",
      "Seal No.": "封箱号",
      "Type": "类型",
      "Create COA": "创建分析证书",
      "Certification Of Analysis": "分析报告认证",
      "To": "给",
      "Inv. No": "发票号",
      "Loading Port": "装货港",
      "Destination Port": "目的港",
      "MFG. date": "生产日期",
      "Expiry date": "有效期",
      "Test date": "检测日期",
      "Package": "包装",
      "Batch No.": "批号",
      "SN": "序列号",
      "Items": "条目",
      "Standard": "标准",
      "Result": "结果",
      "Conclusion": "结论",
      "Analyst": "分析者",
      "Examiner": "检测者",
      "Approved": "通过",
      "CAS No": "化学物质登录号",
      "IUPAC": "国际纯粹与应用化学联合会",
      "Create COO": "创建原产地证书",
      "Original": "原件",
      "Exporter": "出口商",
      "Serial No.": "序列号",
      "Certificate No.": "证书编号",
      "Certification of Origin": "原产地证书",
      "Means Of Transport And Route": "运输方式和路线",
      "Country / Region of Destination": "目的地国家/地区",
      "For Certifying Authority Use Only": "仅供认证机构使用",
      "Marks and No.": "唛头及编号",
      "No. and Kind of Packages; Description of Goods": "包装件数及种类；货物描述",
      "H.S Code": "协调制度编码",
      "No. and Date of Invoices": "发票编号及日期",
      "Declaration by Exporter": "出口商声明",
      "Place and Date, Signature and Stamp of Authorized Signatory": "地点、日期、授权签字人的签名及印章",
      "Certification": "证明",
      "Place and Date, Signature and Stamp of Certifying Authority": "认证机构的地点、日期、签名及印章",
      "Create Packing List": "创建装箱清单",
      "Packing List": "装箱清单",
      "SC No.": "销售合同编号",
      "Table Columns": "表格列",
      "Mark": "唛头",
      "PKG": "包装",
      "G.W. (Gross Weight)": "毛重",
      "N.W. (Net Weight)": "净重",
      "Measurement ": "体积",
      "Total Packed In": "总包装数量 / 总装载方式",
      "Total Gross Weight": "总毛重",
      "Total Net Weight": "总净重",
      "Setup": "设置/配置",
      "GENERAL": "总体、一般",
      "Personal Settings": "个人设置",
      "Company Settings": "公司设置",
      "Company Bank": "公司银行",
      "User Management": "用户管理",
      "Security Control": "安全检查",
      "Profiles": "档案",
      "Roles And Sharing": "角色与共享",
      "System Setting": "系统设置",
      "Terms & Conditions": "条款与条件",
      "Master": "主管",
      "Expense Ledger Group": "费用账目组",
      "Shipping Line Master": "航运公司经理",
      "Freight Forward Master": "货运代理主管",
      "Custom Clearing Agency": "清关代理机构",
      "Products": "产品",
      "Products Group": "产品组",
      "Manage Products": "管理产品",
      "Unit Master": "单位主数据 / 单位基准",
      "Business Master": "商业事务",
      "Contact Group": "联络小组",
      "Contact Types": "接触类型",
      "Status Master": "状态主数据 / 单位基准",
      "Task Statuses": "任务状态",
      "Ratings": "评级",
      "Lead Statuses": "潜在客户状态",
      "Lead Sources": "潜在客户来源",
      "Loss Reasons": "丢失原因",
      "Priorities": "优先级",
      "Customization": "定制化",
      "Modules": "模块",
      "Template": "模板",
      "Color Plate": "色版",
      "Subscription Plans": "订阅计划",
      "Subscription History": "订阅记录",
      "Update Company": "更新公司信息",
      "Company URL": "公司网址",
      "Telephone": "电话",
      "Fax": "传真",
      "Address": "地址",
      "Address Line One": "地址第一行",
      "Address Line Two": "地址第二行",
      "Pincode": "邮政编码",
      "GSTIN": "商品和服务税识别号码",
      "Fiscal Year Begin Month": "财政年度开始月份",
      "Financial Year Start": "财政年度开始",
      "Financial Year End": "财政年度结束",
      "Create Company Bank": "创建公司银行",
      "Bank Name": "银行名称",
      "Account Number": "账号",
      "Account Holder Name": "账户持有人姓名",
      "SWIFT Code": "银行代码",
      "IFSC Code": "印度金融系统代码 ",
      "Bank Branch": "银行分支",
      "Bank Address": "银行地址",
      "Ledger": "收支总账",
      "Ledger Name": "账本名称",
      "Ledger Short Name": "账本简称",
      "Shipping Line Name": "航运公司名称",
      "Short Name": "简称",
      "Agency": "代理商",
      "Agency Name": "代理商名称",
      "Mobile Number": "手机号码",
      "Phone Number": "电话号码",
      "Select Color": "选择颜色",
      "Product Group": "产品组",
      "Product Group Name": "产品组名称",
      "Add Product": "添加产品",
      "Client": "客户；委托人",
      "Client Company": "客户公司",
      "Product Details": "产品细节",
      "HSN Number": "海关编码",
      "Duty Percentage": "关税税率",
      "Tax Percentage": "税收比率",
      "Alternate Unit": "替代单位/备用单位",
      "Primary Quantity": "基本数量",
      "Primary Unit": "基本单位",
      "Secondary Quantity": "备用数量",
      "Secondary Unit": "次要单位",
      "Unit Type": "单位类型",
      "Short Form of Unit": "单位缩写",
      "Formal Name": "正式名称",
      "Unit Quality Code (UQC)": "单位质量代码",
      "No. Of Decimal Places": "小数位数",
      "Business Group Name": "商业群名称",
      "Contact Group Name": "联系人组名称",
      "Contact Type Name": "联系类型名称",
      "Task Status": "任务状态",
      "Rating Name": "评级名称",
      "Priority": "优先级",
      "Lead Source": "潜在客户来源",
      "Loss Reason Name": "丢失原因名称",
      "Priority Name": "优先级名称",
      "Price Estimate": "价格预估",
      "Basic Subscription Fees": "基本订阅费用",
      "2 users and 1 Company Included*": "包含 2 名用户和 1 家公司",
      "Per 12 Month": "每12个月",
      "Users Subscription": "用户订阅",
      "Company Subscription": "公司订阅",
      "Discounted Price (10% OFF)": "折扣价（10%优惠）",
      "Yearly Total Subscription Amount": "年度总订阅金额",
      "Add Users and Company to Your Existing Subscription Plan": "将用户和公司添加到您现有的订阅计划中",
      "Additional Users": "额外的用户",
      "Additional Company": "额外的公司",
      "Note: Price is applied per user and company with the remaining subscription days": "注意：价格按每位用户及每家公司按剩余的订阅天数计算。",
      "Create Call": "创建通话",
      "Select Call Type": "选择通话类型",
      "Select Contact Person": "选择联系人",
      "Subject": "主题",
      "Calling Type": "呼叫类型",
      "Inbound": "呼入",
      "Outbound": "外呼",
      "Call Details": "通话详情",
      "Current": "当前",
      "Complete": "完成",
      "Scheduled": "预先安排",
      "Call Start Time": "呼叫开始时间",
      "Call Duration": "通话时长",
      "Call Purpose": "通话目的",
      "Call Outcome": "通话结果",
      "Lead Stage": "潜在客户阶段",
      "Loss Reason": "丢失原因",
      "Create Task": "创建任务",
      "Task Owner": "任务持有者",
      "Assign To": "分配给",
      "Task": "任务",
      "overView": "概述",
      "purchase Order": "采购订单",
      "booking": "订购；预定",
      "payment": "支付",
      "expense": "支出",
      "receipt Voucher": "收据凭证",
      "Duty/Tax": "关税/税款",
      "tracker": "追踪器",
      "document": "文件",
      "sales Order": "销售订单",
      "sales contract": "销售合同",
      "expense voucher": "费用凭证",
      "bL draft": "提单草稿",
      "COA": "分析证书",
      "COO": "原产地证书",
      "shipment booking": "订舱",
      "is required": "必须",
      "ID": "证件号",
      "From Date": "起始日期",
      "To Date": "到期日",
      "CIF": "到岸价",
      "FOB": "离岸价",
      "Types": "类型",
      "Search": "搜索",
      "Update": "更新",
      "Information": "信息；资料",
      "Shipment": "运输",
      "Others": "其他",
      "Charges": "费用",
      "Sea": "海洋",
      "BL Charges": "提单相关费用",
      "conversion": "转换",
      "In": "在...内",
      "Bank Charges": "银行费用",
      "due": "到期",
      "receipt": "发票，收据",
      "Attach": "附带；扣押",
      "Voucher": "凭证",
      "Sales": "销售",
      "Order": "订单",
      "Contract": "合同",
      "BL": "提单",
      "Draft": "草稿",
      "of": "...的",
      "Containers": "集装箱",
      "Product": "产品",
      "Port": "港口",
      "Loading": "装货",
      "Destination": "目的地",
      "CFS": "装箱货运站",
      "Local Charges": "当地费用",
      "Base": "基本",
      "Others Charges": "其他费用",
      "Per Con.": "每个容器",
      "are required": "必须",
      "Clearing": "清除",
      "PI": "形式发票",
      "CI": "商业发票",
      "Final": "最后的",
      "select Against": "选择反对",
      "Commercial": "商业的",
      "Invoice": "发票",
      "proforma": "形式的",
      "Inv.": "发票",
      "HSN": "协调制度",
      "And": "和",
      "New": "新的",
      "Upload": "上传",
      "Write": "写",
      "a": "一个",
      "is": "是",
      "are": "是",
      "no": "不",
      "number": "号码",
      "more": "更多",
      "For Certifiying authority use Only": "仅供认证机构使用",
      "It is hereby certified that the declaration by the exporter is correct.": "兹证明出口商的申报内容正确无误。",
      "Details": "详情",
      "Add": "添加",
      "item": "项目",
      "words": "语言；字",
      "No Record Found": "未找到记录",
      "Related List": "相关列表",
      "list": "列表",
      "line": "行",
      "on": "在...上",
      "delete": "删除",
      "Financial Year": "财政年度",
      "Date Format": "日期格式",
      "Language": "语言",
      "Shipment ID Setting": "货运单号设置",
      "Import Shipment Prefix and suffix Setting": "进口货运单前缀和后缀设置",
      "Export Shipment Prefix and suffix Setting": "出口货运单前缀和后缀设置",
      "Prefix": "前缀",
      "suffix": "后缀",
      "Setting": "设置",
      "Active Subscription": "有效订阅",
      "Buy Subscription": "购买订阅",
      "Subscription Purchase History": "订阅购买记录",
      "Buy Users and Company": "购买用户与公司",
      "Subscription": "订阅",
      "History": "记录",
      "Buy": "购买",
      "Active": "有效；活跃",
      "Subsription Will Expired in": "购买将于...到期。",
      "days": "天",
      "Monthly": "每月的",
      "Yearly": "每年的",
      "Basic Subcription Fees": "基本订阅费用",
      "at": "在",
      "price": "价格",
      "Add Users and Company To Your Exisiting Subcription Plan": "将用户和公司添加到您现有的订阅计划中",
      "now": "现在",
      "Buy Now": "现在购买",
      "with": "和",
      "Related": "相关的",
      "calls": "通话",
      "Call": "致电",
      "tasks": "任务",
      "Term & Conditions": "条款与条件",
      "Term": "条款",
      "Terms": "条款",
      "Conditions": "条件",
      "group": "组，群",
      "Manage": "管理",
      "Persentage": "百分比",
      "Module": "模块",
      "Color": "颜色",
      "Forward": "前锋；远期交易",
      "short": "短的",
      "required": "要求",
      "shipping": "运输",
      "contact": "联系",
      "Person": "人",
      "Form": "表；形式",
      "Quality": "质量",
      "Code": "编码",
      "Decimal": "小数",
      "Places": "地点；放置",
      "business": "商业",
      "lead": "领导",
      "loss": "丢失",
      "Reason": "原因",
      "Free": "免费",
      "wise": "明智的",
      "Proform": "形式",
      "Register": "注册",
      "Batch": "批次",
      "Import": "进口",
      "Export": "出口",
      "Costing": "花费",
      "Cost": "费用",
      "Tracking": "追踪",
      "Imp.": "进口",
      "Exp.": "出口",
      "Balance": "平衡；结存",
      "remaining": "剩下",
      "day": "天",
      "Documents": "文件",
      "Container": "集装箱",
      "per": "每",
      "Transport": "运输",
      "Primary": "基本的",
      "Secondary": "次要的",
      "Without": "没有",
      "custom": "风俗；顾客",
      "expenses": "费用",
      "miscellaneous": "多方面的",
      "by": "通过",
      "Start": "开始",
      "Time": "时间",
      "Duration": "持续时间",
      "Purpose": "目的",
      "Out": "出",
      "Come": "来",
      // @@@@@@@@ google tras.
      "Management": "管理",
      "Owner": "所有者",
      "Name": "姓名",
      "Expected": "预期的",
      "Method": "方法",
      "Packages": "套餐",
      "Serial": "串行",
      "Certificate": "证书",
      "Certifying Authority": "认证机构",
      "Report": "报告",
      "Month": "月份",
      "User": "用户",
      "Roles": "角色",
      "Role": "角色",
      "bank": "银行",
      "Admin": "行政",
      "Login": "登录",
      "Profile": "轮廓",
      "Permission": "允许",
      "Created": "已创建",
      "Import Shipment Id Manual": "导入货运编号手册",
      "Export Shipment Id Manual": "出口货运编号手册",
      "Purchase Order": "采购订单",
      "Sales Order": "销售订单",
      "Suffix": "后缀",
      "No Record Found!": "沒有找到記錄！",
      "calling": "呼叫",
      "Ordered": "已订购",
      "Pending": "待处理",
      "In-Transit": "运输中",
      "Top": "顶部",
      "Payable": "应付",
      "Receive": "接收",
      "Growth": "增长",
      "Progress": "进度",
      "Chart": "图表",
      "assign": "分配",
      "Cut Off": "截止",
      "Aagainst": "对抗",
      "credit": "信用",
      "BOE": "汇票",
      "Seal": "印章",
      "Level": "水平",
      "Photo": "照片",
      "Back": "返回",
      "Next": "下一步",
      "registered": "注册",
      "the People's Republic Of": "中华人民共和国",
      "The undersigned hereby declares that the above details and statements are correct, that the goods were produced in": "下方签字人兹声明上述细节和陈述属实，所述货物生产于",
      "and that they comply with the rules of origin of the People's Republic of": "并符合中华人民共和国的原产地规则",
      "It is hereby certified that the declaration by the exporter is correct": "兹证明出口商的申报内容正确无误",
      "Place and Date, Signature and stamp of Certifying Authority": "地点和日期，认证机构签字并盖章",
      "Place and Date, Signature and stamp of Authorized Signatory": "地点和日期，授权签字人签字并盖章",
      "packing": "包装",
      "Net Weight": "净重",
      "invoices": "发票",
      "Country/Region": "国家/地区",
      "No. and kind of packages;": "件数和包装种类",
      "Description of Goods": "货物描述",





    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
